import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, CountOfUsages, CasesearchViewLogsCount } from "../stores/store_types"

const callCountOfUsagesAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, countOfUsages: CountOfUsages) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/response_results/count_of_usages",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["countOfUsages"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callDownloadResponseResultsAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, blob: Blob) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/response_results.csv",
    {
      headers: headers,
      responseType: "blob",
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString(),
      }
    }
  ).then((response: AxiosResponse) => {
    const mineType = response.headers["content-type"]
    const blob = new Blob([response.data], { type: mineType })
    successCallback(response.headers, blob)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callCountRegistrationsAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, targetMonthRegistrationCount: number, targetMonthSyounikaRegistrationCount: number, targetMonthObstetricsRegistrationCount: number) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/response_results/count_registrations",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers,
      response.data["targetMonthRegistrationCount"],
      response.data["targetMonthSyounikaRegistrationCount"],
      response.data["targetMonthObstetricsRegistrationCount"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callTotalCountRegistrationsAPI = (headers: AuthHeaders, parameter: { corporationId: number }, successCallback: (headers: AxiosResponseHeaders, allRegistrationCount: number) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/response_results/count_total_registrations",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["allRegistrationCount"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

const callCountCasesearchViewLogsAPI = (headers: AuthHeaders, parameter: { corporationId: number, targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, casesearchViewLogsCount: CasesearchViewLogsCount) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/response_results/count_casesearch_view_logs",
    {
      headers: headers,
      params: {
        corporation_id: parameter.corporationId,
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data["casesearchViewLogsCount"])
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { callCountOfUsagesAPI, callDownloadResponseResultsAPI, callCountRegistrationsAPI, callTotalCountRegistrationsAPI, callCountCasesearchViewLogsAPI }
